import { useBook4 } from '@orientaction/hooks_book';
import EbookReaderLayout from './components/EbookReaderLayout';
import Step4Content from './components/Step4Content';
import { useLegacyEbookReader } from './hooks/useLegacyEbookReader';

const EbookDevStep4 = () => {
  const { getMyValueBook, setAll, setId } = useBook4();
  const reader = useLegacyEbookReader({
    getMyValueBook,
    hydrateValue: setAll,
    setId,
  });

  return (
    <EbookReaderLayout {...reader} ebookName="l’Étape 4">
      {(readOnly) => <Step4Content readOnly={readOnly} />}
    </EbookReaderLayout>
  );
};

export default EbookDevStep4;
